export const NAV = {
  root: "site-nav",
  logo: "site-logo",
  linkBio: "nav-link-bio",
  linkProfile: "nav-link-profile",
  linkTrajectory: "nav-link-trajectory",
  linkAchievements: "nav-link-achievements",
  linkGallery: "nav-link-gallery",
  linkContact: "nav-link-contact",
  langSwitch: (code) => `lang-switch-${code}`,
};

export const HERO = {
  root: "hero-section",
  cta: "hero-cta",
  scroll: "hero-scroll",
};

export const BIO = { root: "bio-section" };
export const PROFILE = { root: "profile-section" };
export const TRAJECTORY = { root: "trajectory-section" };
export const ACHIEVE = { root: "achievements-section" };
export const GALLERY = {
  root: "gallery-section",
  filter: (c) => `gallery-filter-${c}`,
  item: (i) => `gallery-item-${i}`,
};
export const CONTACT = {
  root: "contact-section",
  phone: "contact-phone",
  email: "contact-email",
  ig: "contact-ig",
  igManoly: "contact-ig-manoly",
};

// legacy
export const HOME = { emergentLink: "emergent-link" };
